import React, { useCallback, useMemo } from "react";
import { Tooltip } from "antd";
import { copyToClipBoard, DEFAULT_ID, getGuidFirst8 } from "@/utils/utils";

/**
 * @param {Object} props
 * @param {string|React.ReactNode} [props.tooltipTitle] - Tooltip content
 * @param {boolean} [props.useFullGUID] - Whether to show full GUID or just the first 8 characters
 * @param {string} [props.guid] - The GUID to display
 * @param {Object} [props.itemStyle] - Optional styles for the text
 */
const CopyableGUID = ({ tooltipTitle, useFullGUID = false, guid = DEFAULT_ID, itemStyle = {} }) => {
  const copyableString = useMemo(() => {
    return useFullGUID ? guid : getGuidFirst8(guid);
  }, [guid, useFullGUID]);

  const onClick = useCallback(
    event => {
      // Handle case where this is placed in a table component that normally navs to a details view on row click
      event.stopPropagation();

      copyToClipBoard(copyableString);
    },
    [copyableString],
  );

  const displayedTooltipTitle = useMemo(() => {
    if (typeof tooltipTitle === "string") return tooltipTitle;

    return `Copy to clipboard: ${copyableString}`;
  }, [tooltipTitle, copyableString]);

  const style = useMemo(() => {
    return {
      cursor: "pointer",
      ...itemStyle,
    };
  }, [itemStyle]);

  return (
    <Tooltip color="#fff" title={displayedTooltipTitle}>
      <span onClick={onClick} style={style}>
        {copyableString}
      </span>
    </Tooltip>
  );
};

export default CopyableGUID;
